import React, { useEffect, useState } from 'react';

import './ChatAvatar.css';

const getInitials = (name?: string): string => {
  if (!name) return '';
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return (parts[0][0] || '').toUpperCase();
};

type ChatAvatarProps = {
  className?: string;
  image?: string | null;
  name?: string;
  onClick?: (event: React.BaseSyntheticEvent) => void;
  onMouseOver?: (event: React.BaseSyntheticEvent) => void;
  [key: string]: any;
};

const ChatAvatar: React.FC<ChatAvatarProps> = ({
  className,
  image,
  name,
  onClick,
  onMouseOver,
}) => {
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgError(false);
  }, [image]);

  const initials = getInitials(name);
  const showImage = image && !imgError;

  return (
    <div
      className={`chat-avatar ${className || ''}`}
      onClick={onClick}
      onMouseOver={onMouseOver}
      role="button"
      title={name}
    >
      {showImage ? (
        <img
          alt={initials}
          className="chat-avatar__image"
          onError={() => setImgError(true)}
          src={image}
        />
      ) : (
        <span className="chat-avatar__initials">{initials}</span>
      )}
    </div>
  );
};

export default ChatAvatar;
